// Status Filter
export const status = {
	computed: {
		statuses() {
			return this.$store.getters.getUserStatus.map(status => {
				return {
					id: status.id,
					value: status.translated_name
				}
			})
		}
	},

	watch: {
		'statuses.length': {
			handler: function (length) {
				this.options?.filters.find(({key, option}) => {
					if (key === 'status') option.push(...this.statuses)
				})
			},
			immediate: true
		}
	},
	
	mounted() {
		setTimeout(() => {
			this.$store.dispatch('getUserStatus')
		}, 1000)
	}
}

// Trip Status Filter
export const statusTrip = {
	computed: {
		status() {
			return this.$store.getters.getStatusTrip.map(status => {
				return {
					id: status.id,
					value: status.name
				}
			})
		}
	},

	watch: {
		'status.length': {
			handler: function (length) {
				this.options?.filters.find(({ key, option }) => {
					if (key === 'status') option.push(...this.status)
				})
			},
			immediate: true
		}
	},

	mounted() {
		setTimeout(() => {
			this.$store.dispatch('getStatus')
		}, 1000)
	}
}

// Product Filter
export const productTrip = {
	computed: {
		products() {
			return this.$store.getters.getProductTrip.map(product => {
				return {
					id: product.id,
					value: product.name
				}
			})
		}
	},

	watch: {
		'products.length': {
			handler: function (length) {
				this.options?.filters.find(({ key, option }) => {
					if (key === 'products') option.push(...this.products)
				})
			},
			immediate: true
		}
	},

	mounted() {

		setTimeout(() => {
			this.$store.dispatch('getProducts')
		}, 1000)
	}
}

// Client Filter
export const clientTrip = {
	computed: {
		clients() {
			return this.$store.getters.getClientTrip.map(client => {
				return {
					id: client.id,
					value: client.name
				}
			})
		}
	},

	watch: {
		'clients.length': {
			handler: function (length) {
				this.options?.filters.find(({ key, option }) => {
					if (key === 'clients') option.push(...this.clients)
				})
			},
			immediate: true
		}
	},

	mounted() {

		setTimeout(() => {
			this.$store.dispatch('getClients')
		}, 1000)
	}
}

// Site Filter
export const siteTrip = {
	computed: {
		sites() {
			return this.$store.getters.getSiteTrip.map(site => {
				return {
					id: site.id,
					value: site.name
				}
			})
		}
	},

	watch: {
		'sites.length': {
			handler: function (length) {
				this.options?.filters.find(({ key, option }) => {
					if (key === 'sites') option.push(...this.sites)
				})
			},
			immediate: true
		}
	},

	mounted() {

		setTimeout(() => {
			this.$store.dispatch('getSites')
		}, 1000)
	}
}

// Transporter Filter
export const transporterTrip = {
	computed: {
		transporters() {
			return this.$store.getters.getTransporterTrip.map(transporter => {
				return {
					id: transporter.id,
					value: transporter.name
				}
			})
		}
	},

	watch: {
		'transporters.length': {
			handler: function (length) {
				this.options?.filters.find(({ key, option }) => {
					if (key === 'transporters') option.push(...this.transporters)
				})
			},
			immediate: true
		}
	},

	mounted() {

		setTimeout(() => {
			this.$store.dispatch('getTransporters')
		}, 1000)
	}
}

// Location Filter
export const locationTrip = {
	computed: {
		locations() {
			return this.$store.getters.getLocationTrip.map(location => {
				return {
					id: location.id,
					value: location.name
				}
			})
		}
	},

	watch: {
		'locations.length': {
			handler: function (length) {
				this.options?.filters.find(({ key, option }) => {
					if (key === 'locations') option.push(...this.locations)
				})
			},
			immediate: true
		}
	},

	mounted() {

		setTimeout(() => {
			this.$store.dispatch('getLocations')
		}, 1000)
	}
}

// Escorter Filter
export const escorterTrip = {
	computed: {
		escorters() {
			return this.$store.getters.getEscorterTrip.map(escorter => {
				return {
					id: escorter.id,
					value: escorter.name
				}
			})
		}
	},

	watch: {
		'escorters.length': {
			handler: function (length) {
				this.options?.filters.find(({ key, option }) => {
					if (key === 'escorters') option.push(...this.escorters)
				})
			},
			immediate: true
		}
	},

	mounted() {

		setTimeout(() => {
			this.$store.dispatch('getEscorters')
		}, 1000)
	}
}

// Destination Filter
export const destinationTrip = {
	computed: {
		destinations() {
			return this.$store.getters.getDestinationTrip.map(destination => {
				return {
					id: destination.id,
					value: destination.name
				}
			})
		}
	},

	watch: {
		'destinations.length': {
			handler: function (length) {
				this.options?.filters.find(({ key, option }) => {
					if (key === 'destinations') option.push(...this.destinations)
				})
			},
			immediate: true
		}
	},

	mounted() {

		setTimeout(() => {
			this.$store.dispatch('getDestinations')
		}, 1000)
	}
}

// Transit Filter
export const transitTrip = {
	computed: {
		transits() {
			return this.$store.getters.getTransitTrip.map(transit => {
				return {
					id: transit.id,
					value: transit.name
				}
			})
		}
	},

	watch: {
		'transits.length': {
			handler: function (length) {
				this.options?.filters.find(({ key, option }) => {
					if (key === 'transits') option.push(...this.transits)
				})
			},
			immediate: true
		}
	},

	mounted() {

		setTimeout(() => {
			this.$store.dispatch('getTransits')
		}, 1000)
	}
}

// Transit Filter
export const vehiculeTrip = {
	computed: {
		vehicules() {
			return this.$store.getters.getVehiculeTrip.map(vehicule => {
				return {
					id: vehicule.id,
					value: vehicule.name
				}
			})
		}
	},

	watch: {
		'vehicules.length': {
			handler: function (length) {
				this.options?.filters.find(({ key, option }) => {
					if (key === 'vehicules') option.push(...this.vehicules)
				})
			},
			immediate: true
		}
	},

	mounted() {

		setTimeout(() => {
			this.$store.dispatch('getVehicules')
		}, 1000)
	}
}

// User Filter
export const userTrip = {
	computed: {
		users() {
			return this.$store.getters.getUserTrip.map(user => {
				return {
					id: user.id,
					value: user.name
				}
			})
		}
	},

	watch: {
		'users.length': {
			handler: function (length) {
				this.options?.filters.find(({ key, option }) => {
					if (key === 'createdBy') option.push(...this.users)
				})
			},
			immediate: true
		}
	},

	mounted() {

		setTimeout(() => {
			this.$store.dispatch('getSupportUsers')
		}, 1000)
	}
}